import ReactDOM from 'react-dom';

import WebForm from './web-form';

function checkWebFormUrl() {
  const reg = /\?web_form_key=.+/;
  return reg.test(window.location.search);
}

async function start() {
  if (checkWebFormUrl()) {
    ReactDOM.render(<WebForm />, document.getElementById('root'));
  } else {
    const { startApp } = await import('./startApp');
    // eslint-disable-next-line no-console
    startApp().catch(console.error);
  }
}

start();

export {};
